import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

export const usePaymentCheck = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const checkPayment = async (userId: any) => {
    try {
      setLoading(true);
      await ApiFetch.httpGetPublic(
        URLS.get.user.payment.paymentCheck.userId(userId)
      );
    } catch (err) {
      setLoading(false);
      setError({
        message: "Payment failed, please try again.",
        status: true,
      });
      console.error("Something went wrong:", err);
    }
  };
  const values = {
    checkPayment,
    loading,
    error,
  };

  return values;
};
